import Form from './AwardsForm'
import isEmpty from './AwardsIsEmpty'
import Section from './AwardsSection'
import Thumbnail from './AwardsThumbnail'

export default { Form, isEmpty, Section, Thumbnail }
